import {
	Component,
	Event,
	EventEmitter,
	FunctionalComponent,
	h,
	Host,
	Listen,
	Method,
	Prop,
	State,
	VNode,
} from "@stencil/core"
import "urlpattern-polyfill"
import { Icon } from "../../../model"

@Component({
	tag: "smoothly-app-room",
	styleUrl: "style.css",
	scoped: true,
})
export class SmoothlyAppRoom {
	private query?: string
	@Prop({ reflect: true }) label?: string
	@Prop({ reflect: true }) icon?: Icon
	@Prop({ reflect: true }) disabled: boolean
	@Prop() path: string | URLPattern | (string | URLPattern)[] = ""
	@State() paths: URLPattern[]
	@Prop({ reflect: true, mutable: true }) selected?: boolean
	@Prop() content?: VNode | FunctionalComponent
	@State() mobileMode = false
	@Event() smoothlyRoomSelect: EventEmitter<{ history: boolean; path: string; query?: string }>
	@Event() smoothlyRoomLoad: EventEmitter<{ selected: boolean }>
	@Event() smoothlyUrlChange: EventEmitter<string>
	private contentElement?: HTMLElement
	componentDidRender() {
		this.selected && this.smoothlyUrlChange.emit(window.location.href)
	}
	componentWillLoad() {
		const stringOrPatternPaths = Array.isArray(this.path) ? this.path : [this.path]
		this.paths = stringOrPatternPaths.map(path => (typeof path == "string" ? new URLPattern({ pathname: path }) : path))
		this.selected = this.paths.some(pattern => pattern.test(window.location.href))
		this.smoothlyRoomLoad.emit({ selected: this.selected })
		this.selected && window.history.replaceState({ smoothlyPath: this.paths[0].pathname }, "", window.location.href)
	}
	@Method()
	async setMobileMode(mobile: boolean) {
		this.mobileMode = mobile
	}
	@Method()
	async getContent(): Promise<HTMLElement | undefined> {
		return this.contentElement
	}
	@Method()
	async setSelected(selected: boolean, options?: { history?: boolean }): Promise<void> {
		this.selected = selected
		if (selected) {
			this.smoothlyRoomSelect.emit({ history: !!options?.history, path: this.paths[0].pathname, query: this.query })
		}
	}
	@Listen("smoothlyUrlUpdate", { target: "window" })
	async setQuery(event: CustomEvent<{ query?: string; path: string }>): Promise<void> {
		if (event.detail.path == this.path && this.query != event.detail.query) {
			this.query = event.detail.query
			window.history.pushState(
				{ smoothlyPath: this.path, smoothlyQuery: this.query },
				"",
				`${window.location.pathname}${this.query ? `?${this.query}` : ""}`
			)
			this.smoothlyUrlChange.emit(window.location.href)
		}
	}

	clickHandler(event: MouseEvent) {
		if (!event.metaKey && !event.ctrlKey && event.which != 2 && event.button != 1) {
			event.preventDefault()
			this.setSelected(true)
		}
	}

	render() {
		return (
			<Host class={{ "smoothly-mobile-mode": this.mobileMode }}>
				<li>
					<a href={this.paths[0]?.pathname} onClick={e => this.clickHandler(e)}>
						{this.icon && <smoothly-icon name={this.icon} />}
						{this.label && <span class="label">{this.label}</span>}
					</a>
				</li>
				<div ref={e => (this.contentElement = e)}>
					{this.content && <smoothly-lazy content={this.content} />}
					<slot />
				</div>
			</Host>
		)
	}
}
